module.exports = __webpack_public_path__ + "img/footer-i.e6d89008.svg";